import { Carousel } from 'antd';
import Login from './login';
import LogoSideLine from '../../assets/images/logo-side-line.svg';
import UserPlaceholder from '../../assets/images/dawson.png';
import UserPlaceholder2 from '../../assets/images/luke.jpeg';
import MainLogo from '../../assets/images/logo.png';
import './auth.css';
import { Avatar, Box, Grid2 as Grid, Typography } from '@mui/material';
import VersionInfo from '@atoms/VersionInfo';

export default function Auth() {
    return (
        <Grid
            container
            className="auth-inner-container"
            flexDirection={{ xs: 'row', md: 'row-reverse' }} // place login on right when on desktop
        >
            <Grid size={{ xs: 12, md: 6 }} className="auth-right-wrapper">
                <div className="auth-form-wrapper">
                    <div className="auth-form-logo-wrapper">
                        <img src={MainLogo} style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <div className="auth-form-box">
                        <Login />
                    </div>
                </div>
                <Box paddingY={2} paddingBottom={{ xs: 15, md: 2 }}>
                    <VersionInfo small />
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className="auth-left-wrapper">
                <div className="auth-left-wrapper-inner pt-5">
                    <div className="auth-left-content-ist-section">
                        <div className="auth-content-header">
                            <Typography variant="h2">
                                Tracking
                                <br />
                                <span className="font-style-italic">Wrestling</span>
                                <br />
                                Just Got Easier.
                            </Typography>
                        </div>

                        <div className="testimonial-slider">
                            <Carousel
                                autoplay={true}
                                slidesToShow={1}
                                dots={true}
                                infinite={true}
                                className="bundle-slider"
                            >
                                <div className="testimonial-card">
                                    <div className="testimonial-content">
                                        <h3>Solid foundation for any team</h3>
                                        <p>
                                            &apos; BoutPro has revolutionized the way we manage
                                            wrestling. The intuitive interface and comprehensive
                                            features make tracking and organizing events a breeze.
                                            Highly recommend it to any wrestling coach! &apos;
                                        </p>
                                    </div>
                                    <div className="user-details">
                                        <div className="user-detail-inner">
                                            <Avatar src={UserPlaceholder} />

                                            <div className="user-info">
                                                <h3>Dawson Peck</h3>
                                                <p>Head Coach @boutpro</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-card">
                                    <div className="testimonial-content">
                                        <h3>Solid foundation for any event</h3>
                                        <p>
                                            &apos; Managing a wrestling team has never been easier.
                                            BoutPro provides all the necessary features to keep
                                            track of athletes' progress and upcoming events. It's a
                                            must-have for any serious team manager. &apos;
                                        </p>
                                    </div>
                                    <div className="user-details">
                                        <div className="user-detail-inner">
                                            <Avatar src={UserPlaceholder2} />
                                            <div className="user-info">
                                                <h3>Luke</h3>
                                                <p>Developer @boutpro</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>

                    <div className="logo-side-line pt-5">
                        <img src={LogoSideLine} />
                    </div>
                </div>
            </Grid>
        </Grid>
    );
}
